document.addEventListener("DOMContentLoaded", function() {
    function isMobileViewport() {
      return window.innerWidth < 768;
    }

    function collapseKlevuFilters() {
      if (isMobileViewport()) {
        var filterHeadings = document.querySelectorAll(".kuFilterHead");
        if (filterHeadings) {
          filterHeadings.forEach(function(filterHeading) {
            filterHeading.click();
          });
        }
      }
    }

    function waitForElement(selector, callback) {
      var elements = document.querySelectorAll(selector);
      if (elements.length) {
        callback(elements);
      } else {
        setTimeout(function() {
          waitForElement(selector, callback);
        }, 100);
      }
    }

    function waitForKlevuSearch(callback) {
      if (typeof klevu !== "undefined" && klevu.search.landing.getScope().template) {
        callback();
      } else {
        setTimeout(function() {
          waitForKlevuSearch(callback);
        }, 100);
      }
    }

    waitForKlevuSearch(function() {
      waitForElement(".kuFilterHead", collapseKlevuFilters);
    });
  });
